import cx from "classnames";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { withToast } from "../../contexts/toastr.context";
import PlusBoxGrayIcon from "../../_assets/vectors/plus-box-gray.svg";
import { getDirectMessagePageRoute } from "../../_pages/direct-message/direct-message.page";
import { MessageService } from "../../_service/message.service";
import { getAllDirectChats } from "../../_store/_actions/direct-message.actions";
import { setPersonalGroup } from "../../_store/_actions/personal-group.actions";
import I18 from "../atoms/i18";
import { Avatar } from "../avatar.component";
import CommunityChatMemberList from "../community/community-chat-member-list.component";
import IconButton from "../icon-button.component";
import { useAppService } from "../../hooks/use-app-service";

let initialChatList = [];
function SidebarDirectMessagesSubMenuComponent({
  user,
  community,
  history,
  addToast,
  socket,
  // state
  chats,
  isLoading,
  error,
  // dispatch
  getAllDirectChats,
}) {
  const [communityMemberListVisible, setCommunityMemberListVisible] =
    useState(false);

  // get selected chat user id from url
  const [userId, setUserId] = useState(window.location.pathname.split("/")[2]);
  const [query, setQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const { analyticsService } = useAppService();

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      // set the current chat userId if needed, this will be used to not show unread messages
      setUserId(location.pathname.split("/")[2]);
    });

    return () => {
      unlisten();
    };
  });

  const searchTagsLocally = async () => {
    // let searchList = [];
    // if (query.length > 0) {
    //   searchList = initialChatList.filter((tag) =>
    //     tag.name.toLowerCase().includes(query.toLowerCase())
    //   );
    //   setChats(searchList);
    // } else {
    //   setChats(initialChatList);
    // }
  };
  return (
    <div className="p-3">
      {/* header */}
      <div className="sidebar-heading-holder shadow-sm flex items-center px-1 justify-between">
        <div className="sidebar-heading  theme-text-heading-2 font-semibold">
          <I18>Direct Message</I18>
        </div>
        <IconButton
          iconSmall
          icon={PlusBoxGrayIcon}
          onClick={(e) => {
            analyticsService.track("create-new-chat")
            setCommunityMemberListVisible(true);
          }}
        />
      </div>
      {/* search box */}
      {/* <div>
        {showSearch ? (
          <TextInput
            key="1"
            noPrefixSeparator
            placeholder="Search by name"
            noBorder
            validationOutsideBox
            noMargin
            value={query}
            containerClassName="theme-bg-surface py-1 focus:outline-none border theme-border-default rounded mt-4"
            onChange={(value) => {
              setQuery(value);
            }}
            postfix={
              query.length > 0 ? (
                <i
                  onClick={() => {
                    setQuery("");
                    // setChats(initialChatList);
                    setShowSearch(!showSearch);
                  }}
                  className="fi fi-rr-cross theme-text-heading-2 text-sm mr-2 cursor-pointer"
                />
              ) : (
                <></>
              )
            }
          />
        ) : (
          <TextInput
            key="2"
            noPrefixSeparator
            placeholder="Search by name"
            noBorder
            validationOutsideBox
            noMargin
            value={query}
            containerClassName="theme-bg-surface py-1 focus:outline-none border theme-border-default rounded mt-4"
            onChange={(value) => {
              setQuery(value);
            }}
            postfix={
              query.length > 0 ? (
                <i
                  onClick={() => {
                    setQuery("");
                    // setChats(initialChatList);
                    setShowSearch(!showSearch);
                  }}
                  className="fi fi-rr-cross theme-text-heading-2 text-sm mr-2 cursor-pointer"
                />
              ) : (
                <></>
              )
            }
          />
        )}
      </div> */}
      {/* chats list */}
      {/* {
        isLoading ? (
          <div className="text-center">
            Is Loading....
          </div>
        ) : <></>
      } */}
      {chats && (
        <>
          <div className="px-2">
            {chats.map((chatUser) => {
              if (chatUser === undefined) {
                return <></>;
              }
              return (
                <Link
                  key={chatUser.id}
                  to={getDirectMessagePageRoute(chatUser.id)}
                  onClick={() => {
                    // reset the notification count to 0
                    MessageService.markAllMessagesInChatAsRead(
                      user,
                      chatUser.id
                    )
                      .then(() => {
                        const chat = chats.find(
                          (chat) => chat.id === chatUser.id
                        );
                        chat.unreadMessageCount = 0;
                        // TODO: do the api call to mark all messages as read
                        // setChats([...chats]);
                      })
                      .catch((err) => {
                        console.log("could not mark user chat as read", err);
                      });
                  }}
                  className={cx(
                    "items-center hover:theme-text-on-primary hover:theme-bg-primary",
                    {
                      "theme-text-on-primary theme-bg-primary":
                        userId === chatUser.id,
                      "theme-text-subtitle-1": userId !== chatUser.id,
                    }
                  )}>
                  <Avatar
                    user={chatUser}
                    size={24}
                    className={cx(
                      "hover:theme-bg-primary hover:theme-text-on-primary px-2 py-1  my-2  rounded",
                      {
                        "theme-bg-primary": userId === chatUser.id,
                        "theme-text-subtitle-1 hover:theme-bg-default":
                          userId !== chatUser.id,
                      }
                    )}
                    notificationCount={chatUser.unreadMessageCount}
                    textClassName="hover:theme-text-on-primary"
                  />
                </Link>
              );
            })}
          </div>
        </>
      )}
      <CommunityChatMemberList
        community={community}
        user={user}
        isSubscriberListVisible={communityMemberListVisible}
        setIsSubscriberListVisible={setCommunityMemberListVisible}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
  community: state.community,
  personalGroup: state.personalGroup,
  socket: state.socket,
  chats: state.directMessages.users,
  isLoading: state.directMessages.isLoading,
  error: state.directMessages.error,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPersonalGroup: setPersonalGroup,
      getAllDirectChats,
    },
    dispatch
  );

export const SidebarDirectMessagesSubMenu = withToast(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SidebarDirectMessagesSubMenuComponent)
  )
);
